/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import useStyles from "./styles";
import clsx from "clsx";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityIcon from "@material-ui/icons/VisibilityOutlined";

import {
	Grid,
	Button,
	TextField,
	InputAdornment,
	IconButton
} from "@material-ui/core";
import { connect } from "react-redux";
import { Images } from "config/images";
import { Controller, useForm } from "react-hook-form";
import { createNewPasswordAction } from "store/actions/LoginPageAction";
import { useHistory } from "react-router-dom";

const CreatePassword = props => {
	const { createNewPassword } = props;
	const classes = useStyles();

	const history = useHistory();
	const [checkPass, setCheckPass] = useState({
		newPassword: false,
		reNewPassword: false
	});

	const {
		handleSubmit,
		control,
		getValues,
		formState: { errors }
	} = useForm();

	const onSubmit = data => {
		const { newPassword } = data;
		const onSuccess = () => {
			history.push("/home");
		};
		const dataRegister = {
			data: { newPassword: newPassword },
			onSuccess
		};
		createNewPassword(dataRegister);
	};

	const handleClickShowPassword = type => {
		setCheckPass({ ...checkPass, [type]: !checkPass[type] });
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.rootForm }}>
				<Grid
					classes={{ root: classes.btnBack }}
					onClick={() => {
						history.goBack();
					}}
				>
					<img src={Images.icArrowLeftBlack} alt="icArrowLeftBlack" />
				</Grid>
				<Grid classes={{ root: classes.headerRegister }}>
					<img src={Images.icCreatePassword} alt="icCreatePassword" />
					<Grid
						classes={{
							root: clsx(classes.borderTitle)
						}}
					>
						<Grid classes={{ root: classes.titleHeader }}>
							Đăng ký tài khoản
						</Grid>
						<Grid classes={{ root: classes.subTitleHeader }}>
							Vui lòng nhập thông tin để đăng ký
						</Grid>
					</Grid>
				</Grid>
				<form onSubmit={handleSubmit(onSubmit)}>
					<Grid classes={{ root: classes.title }}>
						Mật khẩu <span>(*)</span>
					</Grid>
					<Controller
						control={control}
						name="newPassword"
						rules={{
							required: "Vui lòng nhập password mới"
						}}
						defaultValue={
							getValues("newPassword")
								? getValues("newPassword")
								: ""
						}
						render={({ field }) => (
							<TextField
								{...field}
								type={
									checkPass.newPassword ? "text" : "password"
								}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={() =>
													handleClickShowPassword(
														"newPassword"
													)
												}
											>
												{checkPass.newPassword ? (
													<VisibilityIcon />
												) : (
													<VisibilityOffIcon />
												)}
											</IconButton>
										</InputAdornment>
									)
								}}
								className={clsx(
									classes.customInput,
									errors?.newPassword
										? classes.inputError
										: ""
								)}
							/>
						)}
					/>
					{errors?.newPassword && (
						<Grid classes={{ root: classes.textError }}>
							{errors.newPassword.message}
						</Grid>
					)}
					<Grid classes={{ root: classes.title }}>
						Nhập lại mật khẩu <span>(*)</span>
					</Grid>
					<Controller
						control={control}
						name="reNewPassword"
						rules={{
							required: "Vui lòng nhập lại password mới",
							validate: value =>
								value === getValues("newPassword") ||
								"Không giống với mật khẩu mới"
						}}
						defaultValue={
							getValues("reNewPassword")
								? getValues("reNewPassword")
								: ""
						}
						render={({ field }) => (
							<TextField
								{...field}
								type={
									checkPass.reNewPassword
										? "text"
										: "password"
								}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={() =>
													handleClickShowPassword(
														"reNewPassword"
													)
												}
											>
												{checkPass.reNewPassword ? (
													<VisibilityIcon />
												) : (
													<VisibilityOffIcon />
												)}
											</IconButton>
										</InputAdornment>
									)
								}}
								className={clsx(
									classes.customInput,
									errors?.reNewPassword
										? classes.inputError
										: ""
								)}
							/>
						)}
					/>
					{errors?.reNewPassword && (
						<Grid classes={{ root: classes.textError }}>
							{errors.reNewPassword.message}
						</Grid>
					)}
					<Grid classes={{ root: classes.bodyBtnSubmit }}>
						<Button
							type="submit"
							classes={{ root: classes.btnSubmit }}
						>
							Đăng ký
						</Button>
					</Grid>
				</form>
			</Grid>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {
		createNewPassword: data => {
			dispatch(createNewPasswordAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatePassword);
